import { render, staticRenderFns } from "./CategoryOrSearch.vue?vue&type=template&id=3b71d0c2&scoped=true&"
import script from "./CategoryOrSearch.vue?vue&type=script&lang=js&"
export * from "./CategoryOrSearch.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOrSearch.vue?vue&type=style&index=0&id=3b71d0c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71d0c2",
  null
  
)

export default component.exports